import React, { useCallback, useEffect, useState } from "react";
import Column from "../ColumnComponent/Column";
import { commonPost } from "../../../../../services/reportService";
import { useAuth } from "../../../../../providers/AuthProvider";
import { ReportProps } from "../../../../../types/types";
import { LoadingOverlay } from "@mantine/core";

export function QueryHeaders(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  const Columns = (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.columnsViewReport : props.columns;
  const [loaderShowOnCreateAccount, setLoaderShowOnCreateAccount] =
    useState<boolean>(false);

    const makeList = useCallback ((obj: any): any => {
      let list = Object.keys(obj[0].data[0]);
      let finalColumns = Columns;
      finalColumns["Query_Columns"]["list"] = list;
      return finalColumns;
    },[props.columns, props.columnsViewReport]);

    const getQueryColumns = useCallback(async (): Promise<void> => {
      let url = `/v2/query/columns`;
      let response;
      if(props.currentReportComponent === "viewReport" && props.queryInfoViewReport.query){
        response = await commonPost(url, props.queryInfoViewReport, authContext);
      }        
      else{
          props.queryInfo.extendedAttributes = {param: props.queryInfo.params}
         response = await commonPost(url, props.queryInfo, authContext);
      }      
      if (response != null) {  
        let values = makeList(response.features);
        return values;
      }
    }, [authContext, makeList, props.queryInfo]);

  useEffect(() => {
    const method = async () => {
      //displays loader till there is no response from api
      let queryColumns: any;
      setLoaderShowOnCreateAccount(true);
      if (props.reportInfo.viewEditStatus === "VIEW") {
        queryColumns = Columns;
        let extendedAttributes = (props.currentReportComponent === "viewReport" && props.diffrentQueryForViewReportFlag === "no") ? props.extendedAttributesViewReports : props.reportInfo.extendedAttributes;
        Object.keys(extendedAttributes.headers).forEach(
          (obj) => {
            queryColumns["Report_Columns"].list.push(obj);
          }
        );
      } else {
        queryColumns =
          Columns["Report_Columns"].list.length > 0
            ? Columns
            : await getQueryColumns();
      }

      const cols = JSON.parse(JSON.stringify(queryColumns));
      //sets the data from api to state
      props.currentReportComponent === "viewReport" ? props.setColumnsViewReport(cols) : props.setColumns(cols);
      //loader disappears
      setLoaderShowOnCreateAccount(false);
    };
    method();
  },[]);

  

  //to fetch the columns from the query
  

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        width: "100%",
        height: "100%",
        gap: "6%",
      }}
    >
      {loaderShowOnCreateAccount && (
        <LoadingOverlay
          visible={loaderShowOnCreateAccount}
          style={{ position: "fixed" }}
        />
      )}
      {Object.values(Columns).map((col) => (
        <Column {...props} col={col as any} />
      ))}
    </div>
  );
}
